export const mainMenu = [
    {
        name: 'Новости',
        url: '/news'
    },
    {
        name: 'Мир',
        url: '/world'
    },
    {
        name: 'Россия',
        url: '/russia'
    },
    {
        name: 'Бывший СССР',
        url: '/ussr'
    },
    {
        name: 'Экономика',
        url: '/business'
    },
    {
        name: 'Спорт',
        url: '/sport'
    },
    {
        name: 'Наука',
        url: '/science'
    },
    {
        name: 'Без политики',
        url: '/nopolitics'
    },
    {
        name: 'Мнения',
        url: '/opinion'
    },
    {
        name: 'ИноТВ',
        url: '/inotv'
    },
    {
        name: 'Фото',
        url: '/foto'
    },
    {
        name: 'Видео',
        url: '/video'
    }
];


export const appMenu = [
    {
        name: 'Медальный зачет',
        url: '/olympic2018/medalnyj-zachet-olimpiada-2018'
    },
    {
        name: 'Расписание',
        url: '/olympic2018/kalendar-olimpiada-2018'
    },
    {
        name: 'Материалы',
        url: '/olympic2018/materials/'
    }
    // {
    //     name: 'Участники',
    //     url: '/olympic2018/users/'
    // },

    // {
    //     name: 'Стадионы',
    //     url: '/olympic2018/Stadiums/'
    // }
];



// WEBPACK FOOTER //
// ./src/static-data/menus.js